import search_controller from './search_controller'
import { utility_controller } from '../utility/utility_controller'

var searchShown = false

function SearchView() {
	this.$el = jQuery('.search-view')
	this.val = ''

	var _this = this

	var hasNoResultsClass = 'search-has-no-results'
	var hasResultsClass = 'search-has-or-had-results'

	this.bindEvents = function () {
		_this.$el.find('#search-query').on('input', this.onInput)
		_this.$el.find('#search-query').on('focus', this.onFocus)
		_this.$el.find('#search-query').on('blur', this.onBlur)
		// `.close-search` now lives OUTSIDE `.search-view` (as a sibling
		// inside `#search-region`) so its `position: fixed` works even
		// when `.search-view` has a backdrop-filter that would otherwise
		// trap fixed descendants inside its containing block. Use a
		// document-level delegated handler so the binding still resolves.
		jQuery(document).on('click', '#search-region > .close-search', this.onHide)

		// when someone clicked on a search result hide search window after content in background has faded out?
		window.laytheme.on('content_fadeout_transition_ended', function () {
			_this.onHide()
		})
	}

	this.onFocus = function () {
		_this.$el.find('#search-autosuggest-list').show()
	}
	this.onBlur = function () {
		setTimeout(() => {
			_this.$el.find('#search-autosuggest-list').hide()
		}, 100)
	}
	this.onInput = function () {
		_this.val = _this.$el.find('#search-query').val()
		search_controller.search()
	}
	this.onShow = function () {
		searchShown = true
		_this.$el.addClass('show')
		utility_controller.fixBody(true)
		jQuery('#search-query').focus()
		jQuery('body').addClass('search-open')
	}
	this.onHide = function () {
		if (searchShown) {
			_this.$el.addClass('hide').removeClass('show')
			utility_controller.unfixBody()
			// reset
			_this.$el.find('#search-query').val('')
			_this.val = ''
			_this.onBlur
			search_controller.search()
			_this.addClassForNoResults()
			searchShown = false
			jQuery('body').removeClass('search-open')
			// Lets smooth_scroll_controller tear down the overlay Lenis
			// instance that handles wheel events inside .search-view.
			window.laytheme.emit('searchhidden')
		}
	}
	this.addClassForNoResults = function () {
		_this.$el.addClass(hasNoResultsClass)
		_this.$el.removeClass(hasResultsClass)
	}
	this.addClassForResults = function () {
		_this.$el.removeClass(hasNoResultsClass)
		_this.$el.addClass(hasResultsClass)
	}

	this.bindEvents()
}

function SuggestView(suggest) {
	var _this = this
	this.suggest = suggest
	this.query = jQuery('#search-query').val()

	this.getMarkup = function () {
		return '<div class="suggest-item"><span class="suggest">' + _this.suggest + '</span></div>'
	}

	// this.getMarkup = function () {
	// 	return '<div class="suggest-item"><span class="suggest"><span class="suggest-prefix">' + _this.suggestPrefix() + '</span><span class="suggest-suffix">' + _this.suggestSuffix() + '</span></span></div>'
	// }

	// this.suggestSuffix = function () {
	// 	var auto_complete = _this.suggest
	// 	var searchQuery = _this.query
	// 	if (utility_controller.stringStartsWith(auto_complete, searchQuery)) {
	// 		return auto_complete.slice(searchQuery.length)
	// 	} else {
	// 		return auto_complete
	// 	}
	// }
	// this.suggestPrefix = function () {
	// 	var auto_complete = _this.suggest
	// 	var searchQuery = _this.query
	// 	if (utility_controller.stringStartsWith(auto_complete, searchQuery)) {
	// 		return _this.query
	// 	} else {
	// 		return ''
	// 	}
	// }
}

export { SearchView, SuggestView }
